import { useCallback, useEffect, useRef } from 'react';

const useInfinityScroll = (
  intersectingCallBack: () => void,
  root?: HTMLElement | null,
) => {
  const observer = useRef<IntersectionObserver>();
  const observerRefCallback = useCallback((node: HTMLDivElement | null) => {
    setTimeout(() => {
      if (observer.current) {
        observer.current.disconnect();
      }
      observer.current = new IntersectionObserver(
        (entries) => {
          if (entries[0].isIntersecting) {
            intersectingCallBack();
          }
        },
        { root: root || null },
      );
      if (node) {
        observer.current?.observe(node);
      }
    }, 1000);
  }, []);

  useEffect(() => {
    return () => {
      observer.current?.disconnect();
    };
  }, []);

  return { observerRefCallback };
};
export default useInfinityScroll;
